module.exports = __webpack_public_path__ + "static/media/adobe-xd-logo.3338afff.png";